import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { login } from "../authVerification/authThunk";
import { startExamActivity } from "../../activityAsyncAction";
const initialState = {
  list: [],
  noOfQuestions: 0,
  activeTab: "multichoice",
  hasTheory: true,
  hasMultiChoice: true,
  currentIndex: 0,
  loading: false,
};

export const questionSlice = createSlice({
  name: "questions",
  initialState,
  reducers: {
    updateAnswer: (state, { payload }) => {
      let question = state.list[state.currentIndex];
      let ansSet = new Set(question.answer);
      if (question.type === "multichoice") {
        if (question.numberOfAnswers === 1) {
          console.log("the answer is equal to 1", payload);
          state.list[state.currentIndex].answer = [payload];
        }
        //checks if the answers is completed or the current change already exist
        let multiAnswerVerify = question.answer
          ? question.answer?.length < question.numberOfAnswers ||
            ansSet.has(payload)
          : true;
        if (question.numberOfAnswers > 1 && multiAnswerVerify) {
          console.log("the answer is greater than 1", payload);
          if (ansSet.has(payload)) {
            state.list[state.currentIndex].answer = question.answer.filter(
              (ans) => ans !== payload
            );
          } else {
            state.list[state.currentIndex].answer = [
              ...(question.answer || []),
              payload,
            ];
          }
        }
      } else {
        question.answer = payload;
      }
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    handleNext: (state) => {
      if (state.currentIndex < state.list.length) {
        state.currentIndex = state.currentIndex + 1;
      }
    },
    handlePrev: (state) => {
      if (state.currentIndex > 0) {
        state.currentIndex = state.currentIndex - 1;
      }
    },
    setCurrent: (state, { payload }) => {
      state.currentIndex = payload;
    },
  },
  extraReducers: {
    [startExamActivity.pending]: (state, action) => {
      state.loading = true;
    },
    [startExamActivity.fulfilled]: (state, action) => {
      state.loading = false;
      const {
        data: {
          examActivity: { attemptedQuestions },
          questions,
        },
        message,
      } = action.payload;
      console.log(questions);
      state.hasTheory = questions.some(({ type }) => type === "theory");
      const hasMultiChoice = (state.hasMultiChoice = questions.some(
        ({ type }) => type === "multichoice"
      ));
      state.hasMultiChoice = hasMultiChoice;
      state.activeTab = hasMultiChoice ? "multichoice" : "theory";
      //get the question from api and sort it by question type
      state.list = questions.sort((a, b) => {
        if (a.type === "multichoice" && b.type === "theory") {
          return -1;
        }
        if (a.type === "theory" && b.type === "multichoice") {
          return 1;
        }
        return 0;
      });
      toast.success(message);
      if (attemptedQuestions?.length) {
        //create a js map of _id to index to keep the numbers the same while taking the exam
      }
    },
    [startExamActivity.rejected]: (state, action) => {
      state.loading = false;
      toast.error(action.payload);
      state.list = [];
    },
    [login.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.noOfQuestions = data?.questionCount ?? state.noOfQuestions;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateAnswer,
  handleNext,
  handlePrev,
  setCurrent,
  setActiveTab,
} = questionSlice.actions;

export default questionSlice.reducer;
